import script from "./ReportView.vue?vue&type=script&setup=true&lang=js"
export * from "./ReportView.vue?vue&type=script&setup=true&lang=js"

import "./ReportView.vue?vue&type=style&index=0&id=56acd428&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-56acd428"]])

export default __exports__